export function getLogoTitle() {
  return 'Moluna.de - entdecken, einkaufen, erleben';
}

export function getTelTitle() {
  return 'persönlicher Kundenservice - Moluna anrufen';
}

export function getTelNummber() {
  return '02571/5 69 89 33';
}

export function getTelNummberLink() {
  return 'tel:+4925715698933';
}

export function getHeaderInjection() {
  return (
    <li className="moluna">
      <a href="https://laden.moluna.de/">Unser Laden</a>
    </li>
  );
}
